import { Switch } from '@mui/material';
import React, { forwardRef } from 'react';

type SwitchToggleProps = {
    size?: 'small' | 'medium';
    checked: boolean;
    onHandleToggle: (checked: boolean) => void;
    skuId?: string | null;
    tabIndex?: number;
    disabled?: boolean;
    className?: string;
    onKeyDown?: React.KeyboardEventHandler<HTMLButtonElement>;
};

const SwitchToggle = forwardRef<HTMLInputElement, SwitchToggleProps>(
    ({ className, disabled, size, checked, onHandleToggle, tabIndex, onKeyDown }, ref) => {
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            onHandleToggle(e.target.checked);
        };

        // Custom ref logic to forward to the input
        const setInputRef = (spanEl: HTMLSpanElement | null) => {
            if (spanEl && ref) {
                const input = spanEl.querySelector('input[type="checkbox"]') as HTMLInputElement | null;
                if (input) {
                    if (typeof ref === 'function') {
                        ref(input);
                    } else {
                        (ref as React.MutableRefObject<HTMLInputElement | null>).current = input;
                    }
                }
            }
        };

        return (
            <Switch
                onKeyDown={onKeyDown}
                ref={setInputRef}
                disabled={disabled}
                color="info"
                size={size}
                tabIndex={tabIndex}
                checked={checked}
                onChange={handleChange}
                className={className}
            />
        );
    },
);

export default SwitchToggle;
